import React, {ReactNode, useState} from "react";
import {
  AssignTermPopupConfirmationModal,
  AssignTermPopupConfirmationModalState,
  AssignTermPopupFormReturn,
  ConflictingTermByBuilder,
} from "view/apps/Organiser/pages/Show/Glossary/components/AssignTermPopupToBuildTypeModal/utils/types";
import {UseFormReturn} from "react-hook-form";
import {IBuildType, ITerm} from "@evennt-tech/api-v2-core";
import {ASSIGN_TERM_POPUP_CONFIRMATION_MODAL_DESCRIPTION} from "view/apps/Organiser/pages/Show/Glossary/components/AssignTermPopupToBuildTypeModal/utils/helpers";
import ConfirmationModal from "view/apps/Organiser/pages/Show/Glossary/components/AssignTermPopupToBuildTypeModal/components/ConfirmationModal";

export const useTermPopupConfirmationModal = (
  builders: IBuildType[],
  form: UseFormReturn<AssignTermPopupFormReturn>,
  termById: Record<string, ITerm>,
  onSubmit: (newSelectedBuilderIds: string[]) => Promise<void>
) => {
  const [confirmationModals, setConfirmationModals] = useState<
    AssignTermPopupConfirmationModalState[]
  >([]);

  const {getValues} = form;

  const onConfirmationModalClose = () => setConfirmationModals([]);

  const onConfirmationModalSubmit = async () => {
    if (!confirmationModals.length) {
      return;
    }

    await onSubmit(getValues().selectedBuilderIds);
  };

  const getModalWarnings = (): ReactNode[] => {
    if (!confirmationModals.length) {
      return [];
    }

    const descriptions: ReactNode[] = [];
    for (const confirmationModal of confirmationModals) {
      if (
        confirmationModal.type ===
        AssignTermPopupConfirmationModal.AssignBuilders
      ) {
        const builderNames = confirmationModal.builderIds.reduce<string[]>(
          (acc, curr) => {
            const builder = builders.find((b) => b.id === curr);
            if (builder) {
              acc.push(builder.name);
            }
            return acc;
          },
          []
        );

        descriptions.push(
          ASSIGN_TERM_POPUP_CONFIRMATION_MODAL_DESCRIPTION[
            AssignTermPopupConfirmationModal.AssignBuilders
          ](builderNames)
        );
      }

      if (
        confirmationModal.type === AssignTermPopupConfirmationModal.Unassign
      ) {
        const {conflictingTermByBuilder} = confirmationModal;

        const termTitleByBuilderName = Object.entries(
          conflictingTermByBuilder
        ).reduce<ConflictingTermByBuilder>((acc, [builderId, termId]) => {
          const builderName = builders.find((b) => b.id === builderId)?.name;
          if (!builderName) {
            return acc;
          }
          const termTitle = termById[termId]?.title;
          if (!termTitle) {
            return acc;
          }
          acc[builderName] = termTitle;

          return acc;
        }, {});

        descriptions.push(
          ASSIGN_TERM_POPUP_CONFIRMATION_MODAL_DESCRIPTION[
            AssignTermPopupConfirmationModal.Unassign
          ](termTitleByBuilderName)
        );
      }
    }

    return descriptions;
  };

  const confirmationModalView = confirmationModals.length ? (
    <ConfirmationModal
      onClose={onConfirmationModalClose}
      onSubmit={onConfirmationModalSubmit}
      warnings={getModalWarnings()}
    />
  ) : null;

  return {confirmationModalView, setConfirmationModals};
};
